import { formatLegLine } from "./formatters";

// Small "Leg N" chip above each leg's cards. Includes the compact
// "Player · Side Line Market" one-liner.
export function LegHeader({ leg }) {
  return (
    <div
      data-testid={`analyzer-leg-header-${leg.index}`}
      className="pa-card p-4 md:p-5 mt-6 md:mt-8"
    >
      <div className="flex items-baseline justify-between flex-wrap gap-2">
        <h4 className="font-display uppercase tracking-wide text-slate-900 text-lg">
          Leg {leg.index + 1}
        </h4>
        <p className="text-xs text-slate-500 font-mono-num" data-testid={`analyzer-leg-header-line-${leg.index}`}>
          {formatLegLine(leg)}
        </p>
      </div>
    </div>
  );
}
